import CancellableHelper from "@/requests/CancellableHelper";
import { GetCashDocumentListResponse } from "@/models/api/finances/GetCashDocumentListResponse";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { CashDocumentEdit } from "@/models/api/finances/CashDocumentEdit";
import { CashDocumentItem } from "@/models/api/finances/CashDocumentItem";
import { DoubleConfirm } from "@/models/api/DoubleConfirm";

export const URL_GET_CASH_DOCUMENTS = "/cashDocument/Paged";
export const URL_POST_ADD_CASH_DOCUMENT = "/cashDocument/Add";
export const URL_POST_REMOVE_CASH_DOCUMENT = "/cashDocument/${CashDocumentId}/Remove";
export const URL_POST_CANCEL_CASH_DOCUMENT = "/cashDocument/${CashDocumentId}/Cancel";
export const URL_GET_CASH_DOCUMENT_ITEMS = "/cashDocument/${CashDocumentId}/Items";
export const URL_POST_PAIR_CASH_DOCUMENT_ITEM = "/cashDocument/Pair";
export const URL_POST_UNPAIR_CASH_DOCUMENT_ITEM = "/cashDocument/Unpair";
export const URL_GET_SHOW_CASH_DOCUMENT = "/cashDocument/${CashDocumentId}/ShowDocument";
export const URL_POST_PRINT_CASH_DOCUMENT = "/cashDocument/${CashDocumentId}/PrintDocument";
export const URL_POST_CREATE_PREVIEW_CASH_DOCUMENTS = "/cashDocument/Preview";

const _getCashDocumentsTable = new CancellableHelper<GetCashDocumentListResponse>(
  URL_GET_CASH_DOCUMENTS,
  GetCashDocumentListResponse
);
_getCashDocumentsTable.jsonSerializer = true;
export const getCashDocumentsTable = async (
  genericTableRequest: GenericTableRequest
): Promise<GetCashDocumentListResponse> => {
  return await _getCashDocumentsTable.get(genericTableRequest);
};

const _addCashDocument = new CancellableHelper<null>(URL_POST_ADD_CASH_DOCUMENT, null, true);
export const addCashDocument = async (cashDocumentEdit: CashDocumentEdit): Promise<null> => {
  return await _addCashDocument.post({}, cashDocumentEdit);
};

const _cancelCashDocument = new CancellableHelper<DoubleConfirm>(URL_POST_CANCEL_CASH_DOCUMENT, null, true);
export const cancelCashDocument = async (cashDocumentId: number, confirmed: boolean): Promise<DoubleConfirm> => {
  return await _cancelCashDocument.post({ CashDocumentId: cashDocumentId, Confirmed: confirmed }, null);
};

const _removeCashDocument = new CancellableHelper<DoubleConfirm>(URL_POST_REMOVE_CASH_DOCUMENT, null, true);
export const removeCashDocument = async (cashDocumentId: number, confirmed: boolean): Promise<DoubleConfirm> => {
  return await _removeCashDocument.post({ CashDocumentId: cashDocumentId, Confirmed: confirmed }, null);
};

const _createPreviewCashDocument = new CancellableHelper<number>(URL_POST_CREATE_PREVIEW_CASH_DOCUMENTS, "number");
export const createPreviewCashDocument = async (cashDocumentIds: number[]): Promise<number> => {
  return await _createPreviewCashDocument.post({}, cashDocumentIds);
};

const _reprintCashDocument = new CancellableHelper<DoubleConfirm>(URL_POST_PRINT_CASH_DOCUMENT, null, true);
export const reprintCashDocument = async (cashDocumentId: number, confirmed: boolean): Promise<DoubleConfirm> => {
  return await _reprintCashDocument.post({ CashDocumentId: cashDocumentId, Confirmed: confirmed }, null);
};

const _showCashDocument = new CancellableHelper<Blob>(URL_GET_SHOW_CASH_DOCUMENT);
_showCashDocument.isFile = true;
export const showCashDocument = async (cashDocumentId: number): Promise<void> => {
  CancellableHelper.openFile(await _showCashDocument.get({ CashDocumentId: cashDocumentId }));
};

const _getCashDocumentItems = new CancellableHelper<CashDocumentItem[]>(URL_GET_CASH_DOCUMENT_ITEMS, CashDocumentItem);
export const getCashDocumentItems = async (cashDocumentId: number): Promise<CashDocumentItem[]> => {
  return await _getCashDocumentItems.get({ CashDocumentId: cashDocumentId });
};

const _unpairCashDocumentItem = new CancellableHelper<null>(URL_POST_UNPAIR_CASH_DOCUMENT_ITEM, null, true);
export const unpairCashDocumentItem = async (cashDocumentItemId: number): Promise<null> => {
  return await _unpairCashDocumentItem.post({}, cashDocumentItemId);
};

const _pairCashDocumentItem = new CancellableHelper<null>(URL_POST_PAIR_CASH_DOCUMENT_ITEM, null, true);
export const pairCashDocumentItem = async (cashDocumentItemId: number, documentId: string): Promise<null> => {
  return await _pairCashDocumentItem.post({}, { CashDocumentItemId: cashDocumentItemId, DocumentId: documentId });
};
